import * as React from 'react';

import * as styles from './styles/mobileLayout.css';
import { TActiveScreen } from '../../../../store/activeScreen';
import { GroupsSection } from '../../GroupsSection';
import { SubscriptionsSectionContainer } from '../../SubscriptionsSection';

enum EActiveScreen {
  categoriesGroups = 'categoriesGroups',
  subscriptions = 'subscriptions',
}

export interface IMobileLayoutStoreProps {
  activeScreen: TActiveScreen;
}

export type IMobileLayoutProps = IMobileLayoutStoreProps;

export class MobileLayout extends React.PureComponent<IMobileLayoutProps, {}> {
  public render() {
    const { activeScreen } = this.props;

    return (
      <div className={styles['mobile_layout']}>
        <GroupsSection isActiveScreen={activeScreen === EActiveScreen.categoriesGroups} />
        <SubscriptionsSectionContainer isMobileLayout isActiveScreen={activeScreen === EActiveScreen.subscriptions} />
      </div>
    );
  }
}
